"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24219],{

/***/ 85639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50998);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.body1, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ListItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),

/***/ 43099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), 'GetApp');

exports.Z = _default;

/***/ }),

/***/ 44987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_icons_GetApp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43099);
/* harmony import */ var _material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72063);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);








var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        error: {
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.error.main,
            marginBottom: theme.spacing(1),
            '&>svg': {
                marginRight: theme.spacing(1.5)
            }
        }
    });
});
var DownloadInvoiceButton = function(param) {
    var accountRes = param.accountRes, orderToken = param.orderToken, handleDownloadInvoice = param.handleDownloadInvoice, t = param.t, invoiceDownloadError = param.invoiceDownloadError, isSub = param.isSub;
    var ref, ref1;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !isSub && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    onClick: function() {
                        return handleDownloadInvoice(orderToken);
                    },
                    "data-testid": 'invoice--download__button',
                    className: 'invoice--download__button',
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_GetApp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            fontSize: "small",
                            className: 'invoice--download__icon'
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            asText: true,
                            data: accountRes === null || accountRes === void 0 ? void 0 : (ref = accountRes.data) === null || ref === void 0 ? void 0 : ref.order_download_invoice,
                            defaultText: t('texts:account:order_download_invoice')
                        })
                    ]
                }),
                invoiceDownloadError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    in: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "div",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)('download__invoice__error', classes.error),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Error__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                color: "inherit",
                                fontSize: "small"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                data: accountRes === null || accountRes === void 0 ? void 0 : (ref1 = accountRes.data) === null || ref1 === void 0 ? void 0 : ref1.order_download_invoice_error,
                                defaultText: t('texts:account:order_download_invoice_error')
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DownloadInvoiceButton);


/***/ }),

/***/ 83643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75154);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        takeBackAndRentalOrderList: {
            marginTop: theme.spacing(4)
        },
        orderListTitle: {
            marginBottom: theme.spacing(2)
        },
        orderHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        circleDefault: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.common.black
        },
        circlePrimary: {
            backgroundColor: theme.palette.primary.main
        },
        circleSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        circleWarning: {
            backgroundColor: theme.palette.warning.main
        },
        orderTitle: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: theme.spacing(1)
        },
        orderItem: {
            borderLeft: "1px solid currentColor",
            paddingLeft: theme.spacing(2),
            marginLeft: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        },
        orderItemComing: {
            borderLeft: "1px dashed ".concat(theme.extraColors.greyMedium)
        },
        orderItemReturn: {
            borderLeft: "1px solid ".concat(theme.palette.secondary.main)
        },
        orderItemCancelled: {
            borderLeft: "1px dashed ".concat(theme.palette.warning.main)
        },
        orderItemLast: {
            border: 0
        },
        productCard: _defineProperty({
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            minHeight: 60,
            padding: theme.spacing(1),
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            width: '100%'
        }),
        imgProduct: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            display: 'block'
        },
        imgContainer: _defineProperty({
            width: 50,
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(0)
        }),
        productName: _defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        productReturned: {
            display: 'inline-block',
            textTransform: 'uppercase',
            fontSize: 11,
            color: theme.palette.common.white,
            backgroundColor: theme.extraColors.greyMedium,
            padding: theme.spacing(0, 0.25)
        },
        downloadInvoiceButton: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        warning: {
            color: theme.palette.warning.main
        },
        buyArea: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        cancelArea: {
            textAlign: 'right',
            paddingBottom: '0.3rem'
        },
        cancelBtn: {
            padding: 0,
            textTransform: 'none',
            textDecoration: 'underline',
            fontSize: '80%',
            color: theme.extraColors.greyText,
            '&:hover, &:focus': {
                background: 'none'
            }
        },
        modal: {
            borderRadius: 0,
            '& .MuiPaper-root': _defineProperty({
                borderRadius: 0
            }, theme.breakpoints.up('md'), {
                minWidth: 700
            })
        },
        modalHead: {
            padding: theme.spacing(2, 3),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: theme.extraColors.greyLight,
            '& .MuiTypography-root': {
                fontWeight: 400,
                lineHeight: 1
            }
        },
        modalHeadWarning: {
            display: 'inline-flex',
            alignItems: 'center',
            color: theme.palette.error.main,
            '&>.MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        },
        modalFoot: {
            padding: theme.spacing(1, 2),
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        modalContent: {
            padding: theme.spacing(3),
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(1)
        },
        modalClose: {
            cursor: 'pointer',
            padding: theme.spacing(0.5),
            width: theme.spacing(4),
            height: theme.spacing(4),
            borderRadius: theme.spacing(2),
            textAlign: 'center',
            color: theme.extraColors.greyLight,
            background: theme.extraColors.greyMedium,
            '&:hover, &:focus': {
                background: theme.palette.common.black
            }
        },
        cancelCTA: {
        },
        //second hand order list style
        root: {},
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        takeBackListTitle: {
            marginBottom: theme.spacing(2)
        },
        takeBackListHeader: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center'
        },
        takeBackItemTitle: {
            paddingLeft: theme.spacing(1)
        },
        circle: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main
        },
        productCardCheckbox: {},
        productCardImg: _defineProperty({
            width: 50,
            height: 50,
            position: 'relative',
            marginRight: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginRight: theme.spacing(1)
        }),
        productCardContent: {
            flex: 1
        },
        takeBackItem: {
            borderLeft: "1px solid currentColor",
            paddingLeft: theme.spacing(2),
            marginLeft: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        },
        takeBackItemActive: {
            borderColor: 'transparent',
            paddingLeft: 0,
            marginLeft: theme.spacing(1)
        },
        takeBackItemLast: {
            borderLeft: 0
        },
        productStatus: _defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        takeBackOrder: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: theme.spacing(2),
            width: '100%'
        },
        orderDetailsRow: {
            textAlign: 'right'
        },
        orderDetailsBtn: {},
        orderDetailsRowActions: {
            padding: theme.spacing(1, 0, 2)
        },
        simpleButton: {
            padding: 0,
            textTransform: 'inherit',
            color: theme.extraColors.greyText,
            '&:hover, &:focus': {
                background: 'none'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '.8rem'
            }
        },
        simpleButtonPrimary: {
            color: theme.palette.primary.main
        },
        simpleButtonDanger: {
            color: theme.palette.error.main
        },
        currentOrderList: {
            padding: theme.spacing(3),
            background: theme.palette.common.white
        },
        loaderContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '20vh'
        },
        returnCtaContainer: {
            minHeight: '2rem',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2)
        },
        orderContent: {
            margin: theme.spacing(2, 0)
        },
        OrderTitle: {
            marginBottom: theme.spacing(1)
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useStyles);


/***/ }),

/***/ 53706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14903);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var _Global_DownloadLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84732);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96149);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16502);
/* harmony import */ var _redux_services_order__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39490);
/* harmony import */ var _Order_style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83643);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var RentalReturnLabelDownload = function(param) {
    var orderNumber = param.orderNumber, account = param.account, t = param.t;
    var ref, ref1;
    var classes = (0,_Order_style__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), downloadLink = ref2[0], setDownloadLink = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isUnavailable = ref4[0], setIsUnavailable = ref4[1];
    var handleDownload = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        setIsUnavailable(false);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,_redux_services_order__WEBPACK_IMPORTED_MODULE_8__/* .getOrderReturnLabel */ .k)(orderNumber);
                    case 5:
                        response = _ctx.sent;
                        if (response === null || response === void 0 ? void 0 : response.pdfUrl) {
                            setDownloadLink(response.pdfUrl);
                            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .downloadURI */ .l_)(response.pdfUrl, "".concat("millet", "_").concat(response.trackingCode || orderNumber));
                        } else {
                            setIsUnavailable(true);
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](2);
                        setIsUnavailable(true);
                    case 12:
                        _ctx.prev = 12;
                        setIsLoading(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    9,
                    12,
                    15
                ]
            ]);
        }));
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isUnavailable) {
        var ref5;
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            variant: "body2",
            color: "textSecondary",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                data: account === null || account === void 0 ? void 0 : (ref5 = account.data) === null || ref5 === void 0 ? void 0 : ref5.return_label_unavailable,
                defaultText: t('texts:account:return_label_unavailable')
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        textAlign: "center",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.returnCtaContainer, 'return_label_download'),
        children: downloadLink === '' ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "small",
            "data-testid": "returnLabelDownloadBtn",
            variant: "contained",
            color: "secondary",
            disabled: isLoading,
            onClick: handleDownload,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: isLoading ? classes.hide : classes.show,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        asText: true,
                        data: account === null || account === void 0 ? void 0 : (ref = account.data) === null || ref === void 0 ? void 0 : ref.order_details_generate,
                        defaultText: t('texts:account:order_details_generate')
                    })
                }),
                isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_DownloadLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            downloadLink: downloadLink,
            data: account === null || account === void 0 ? void 0 : (ref1 = account.data) === null || ref1 === void 0 ? void 0 : ref1.order_details_download,
            defaultText: t('texts:account:order_details_download')
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (RentalReturnLabelDownload);


/***/ }),

/***/ 89723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4073);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85639);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var _redux_actions_order__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46194);






var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        formContainer: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            marginLeft: '1.875rem',
            '& .MuiInputLabel-outlined': {
                transform: 'translate(14px, 13px) scale(1)'
            },
            '& .MuiInputLabel-shrink': {
                transform: 'translate(14px, -6px) scale(0.75)'
            }
        },
        formControl: {
            minWidth: 200,
            width: '100%'
        },
        select: {
            '& .MuiOutlinedInput-root': {
                height: 36
            }
        },
        textField: {
            marginTop: theme.spacing(1)
        }
    });
});
var ReturningReasonForm = function(param) {
    var productId = param.productId, returningRaisonId = param.returningRaisonId, returningComment = param.returningComment, onReturningRaisonChange = param.onReturningRaisonChange, onReturningCommentChange = param.onReturningCommentChange, returningReasons = param.returningReasons, getProductReturningReasons1 = param.getProductReturningReasons, locale = param.locale, t = param.t;
    var classes = useStyles();
    var i18n = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().i18n;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!returningReasons || returningReasons.length === 0) {
            getProductReturningReasons1(locale || i18n.language);
        }
    }, []);
    var selectedReason = returningReasons === null || returningReasons === void 0 ? void 0 : returningReasons.find(function(reason) {
        return reason.id === returningRaisonId;
    });
    var isOtherReason = (selectedReason === null || selectedReason === void 0 ? void 0 : selectedReason.code) === 'OTHER';
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.formContainer,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        value: returningRaisonId || '',
                        onChange: function(e) {
                            return onReturningRaisonChange(productId, +e.target.value);
                        },
                        label: t('texts:account:returning_reason_label'),
                        variant: "outlined",
                        select: true,
                        fullWidth: true,
                        inputProps: {
                            displayEmpty: true
                        },
                        classes: {
                            root: classes.select
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                value: ""
                            }),
                            returningReasons === null || returningReasons === void 0 ? void 0 : returningReasons.map(function(reason) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    value: reason.id,
                                    children: reason.translations[0].name
                                }, reason.id);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        id: "returning-reason-comment",
                        value: returningComment,
                        onChange: function(e) {
                            return onReturningCommentChange(productId, e.target.value);
                        },
                        placeholder: t('texts:account:returning_reason_comment_placeholder'),
                        label: t('texts:account:returning_reason_comment_label'),
                        variant: "outlined",
                        fullWidth: true,
                        required: isOtherReason,
                        className: classes.textField,
                        multiline: true,
                        rows: 2
                    })
                })
            ]
        })
    }));
};
var mapStateToProps = function(state) {
    var ref;
    return {
        returningReasons: (ref = state.returnProducts) === null || ref === void 0 ? void 0 : ref.returningReasons
    };
};
var mapDispatchToProps = {
    getProductReturningReasons: _redux_actions_order__WEBPACK_IMPORTED_MODULE_3__/* .getProductReturningReasons */ .pV
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(ReturningReasonForm));


/***/ }),

/***/ 24219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Order_SecondHandAndRentalOrderList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./components/Order/DownloadInvoiceButton/DownloadInvoiceButton.tsx
var DownloadInvoiceButton = __webpack_require__(44987);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./utils/orders.tsx


//get order informations
var getOrderInformations = function(order, index, numberOfOrders) {
    var ref;
    var state;
    var orderStartLeasingDate = order.startLeasingDate;
    var orderEndLeasingDate = order.endLeasingDate;
    var isCancelled = order.shippingState === constants/* ORDER_STATE.CANCELLED */.eZ.CANCELLED;
    var shippingAddress = order.shippingAddress;
    var currentDate = dayjs_min_default()();
    var startLeasingDate = dayjs_min_default()(order.startLeasingDate, 'DD/MM/YYYY');
    var endLeasingDate = dayjs_min_default()(order.endLeasingDate, 'DD/MM/YYYY');
    var checkoutCompletedAt = dayjs_min_default()(order.checkoutCompletedAt).format('DD/MM/YYYY');
    var lastOrder = index + 1 === numberOfOrders;
    var isCancellable = order.isCancellable;
    var tokenValue = order.tokenValue;
    var cancelledAt = order.cancelledAt;
    var shipments = order.shipments;
    var total = (ref = order.totals) === null || ref === void 0 ? void 0 : ref.total;
    if (isCancelled) {
        state = constants/* ORDER_STATE.CANCELLED */.eZ.CANCELLED;
    } else {
        if (currentDate.diff(startLeasingDate, 'day') <= 0) {
            state = constants/* ORDER_STATE.COMING */.eZ.COMING;
        } else if (currentDate.diff(endLeasingDate, 'day') <= 0) {
            state = constants/* ORDER_STATE.RETURN */.eZ.RETURN;
        } else {
            state = constants/* ORDER_STATE.FINISHED */.eZ.FINISHED;
        }
    }
    var rentalOrderList = order.items.filter(function(item) {
        return item.type === constants/* ORDER_ITEM_TYPE.RENTAL */._$.RENTAL;
    });
    var secondHandOrderList = order.items.filter(function(item) {
        return item.type === constants/* ORDER_ITEM_TYPE.SECOND_HAND */._$.SECOND_HAND;
    });
    return {
        orderNumber: order.number,
        rentalOrderList: rentalOrderList,
        secondHandOrderList: secondHandOrderList,
        isCancelled: isCancelled,
        state: state,
        orderStartLeasingDate: orderStartLeasingDate,
        orderEndLeasingDate: orderEndLeasingDate,
        shippingAddress: shippingAddress,
        checkoutCompletedAt: checkoutCompletedAt,
        lastOrder: lastOrder,
        isCancellable: isCancellable,
        tokenValue: tokenValue,
        cancelledAt: cancelledAt,
        shipments: shipments,
        total: total
    };
};

// EXTERNAL MODULE: ./components/Order/Order.style.tsx
var Order_style = __webpack_require__(83643);
;// CONCATENATED MODULE: ./components/Order/RentalOrderList.tsx




var RentalOrderList = function(param) {
    var order = param.order, showSizes = param.showSizes;
    var ref8;
    var classes = (0,Order_style/* default */.Z)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: order === null || order === void 0 ? void 0 : (ref8 = order.rentalOrderList) === null || ref8 === void 0 ? void 0 : ref8.map(function(rentalItem, index) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.productCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.imgContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: ((ref = rentalItem.product.images) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = rentalItem.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.cachedPath),
                                alt: rentalItem.product.name,
                                className: classes.imgProduct
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.productName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: 'h5',
                                children: [
                                    rentalItem.product.name,
                                    showSizes && rentalItem.product.variants !== 'undefined' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ((ref5 = rentalItem === null || rentalItem === void 0 ? void 0 : (ref4 = rentalItem.product) === null || ref4 === void 0 ? void 0 : ref4.variants[0]) === null || ref5 === void 0 ? void 0 : ref5.size) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "\xa0-\xa0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body1',
                                                component: "span",
                                                children: (ref7 = rentalItem === null || rentalItem === void 0 ? void 0 : (ref6 = rentalItem.product) === null || ref6 === void 0 ? void 0 : ref6.variants[0]) === null || ref7 === void 0 ? void 0 : ref7.size
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, rentalItem.product.name + index));
        })
    }));
};
/* harmony default export */ var Order_RentalOrderList = (RentalOrderList);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Error.js
var Error = __webpack_require__(72063);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./hooks/useThrottle.ts
var useThrottle = __webpack_require__(52957);
;// CONCATENATED MODULE: ./components/Order/ModalCancelOrder.tsx











var ModalCancelOrder = /*#__PURE__*/ (0,react.memo)(function(param) {
    var order = param.order, openModal = param.openModal, handleClose = param.handleClose, prismicAccountData = param.prismicAccountData, handleCancel = param.handleCancel;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = (0,Order_style/* default */.Z)();
    var onCancelOrder = (0,useThrottle/* useThrottle */.f)(handleCancel, 500);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        className: (0,clsx_m/* default */.Z)('modal-cancelOrder', classes.modal),
        open: openModal.currentOrder === order.orderNumber,
        onClose: handleClose,
        maxWidth: 'md',
        disableBackdropClick: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('modal-cancelOrder__head', classes.modalHead),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        component: 'h2',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (0,clsx_m/* default */.Z)('modal-cancelOrder__warning', classes.modalHeadWarning),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: prismicAccountData === null || prismicAccountData === void 0 ? void 0 : prismicAccountData.cancel_order_modal_title,
                                        defaultText: t('texts:account:cancel_order:modal_title')
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)('modal-cancelOrder__close', classes.modalClose),
                        onClick: handleClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('modal-cancelOrder__content', classes.modalContent),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: 'h4',
                        component: 'h3',
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: prismicAccountData === null || prismicAccountData === void 0 ? void 0 : prismicAccountData.command,
                                defaultText: t('texts:account:command')
                            }),
                            order.orderNumber || order.number
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: 'div',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: prismicAccountData === null || prismicAccountData === void 0 ? void 0 : prismicAccountData.cancel_order_modal_warn,
                            defaultText: t('texts:account:cancel_order:modal_warn')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: 'primary',
                        variant: 'outlined',
                        size: 'small',
                        className: (0,clsx_m/* default */.Z)('modal-cancelOrder__cta', classes.cancelCTA),
                        onClick: function() {
                            return onCancelOrder(order);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: prismicAccountData === null || prismicAccountData === void 0 ? void 0 : prismicAccountData.cancel_order_modal_cta,
                            defaultText: t('texts:account:cancel_order:modal_cta')
                        })
                    })
                ]
            })
        ]
    }));
});
/* harmony default export */ var Order_ModalCancelOrder = (ModalCancelOrder);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./components/Global/DownloadLink.tsx
var DownloadLink = __webpack_require__(84732);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Order/ReturningReasonForm.tsx
var ReturningReasonForm = __webpack_require__(89723);
;// CONCATENATED MODULE: ./components/Order/SecondHandOrderList.tsx
/* provided dependency */ var process = __webpack_require__(34155);



















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var MainTooltip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        tooltip: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            fontSize: 12,
            textAlign: 'center',
            padding: theme.spacing(1),
            width: '100%'
        },
        arrow: {
            color: theme.palette.secondary.main
        }
    };
})(Tooltip/* default */.ZP);
var mapStateToProps = function(state) {
    return {
        user: state.user,
        stores: state.stores
    };
};
var SecondHandOrderList = function(param1) {
    var takeback = param1.takeback, order = param1.order, main = param1.main, user = param1.user, currentOrderNumber1 = param1.currentOrderNumber, postProductToReturn = param1.postProductToReturn, account = param1.account, stores = param1.stores, getRightOfWithdrawalInfo = param1.getRightOfWithdrawalInfo, savForm = param1.savForm, onOpenSavForm = param1.onOpenSavForm, settings = param1.settings;
    var ref15, ref1, ref2, ref3, ref4;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = (0,Order_style/* default */.Z)();
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var states = productCheckState(takeback);
    var ref5 = (0,react.useState)([]), secondHandRightOfWithdrawalInformations1 = ref5[0], setSecondHandRightOfWithdrawalInformations = ref5[1];
    var ref6 = (0,react.useState)(true), isManageOrderButtonDisabled = ref6[0], setIsManageOrderButtonDisabled = ref6[1];
    var ref7 = (0,react.useState)(false), activeManageOrder = ref7[0], setActiveManageOrder = ref7[1];
    var ref8 = (0,react.useState)(false), productSelection = ref8[0], setProductSelection = ref8[1];
    var ref9 = (0,react.useState)([]), productToReturn = ref9[0], setProductToReturn = ref9[1];
    var ref10 = (0,react.useState)({}), productReturningReasons = ref10[0], setProductReturningReasons = ref10[1];
    var warehouseId1 = (stores === null || stores === void 0 ? void 0 : (ref15 = stores.selectedStore) === null || ref15 === void 0 ? void 0 : ref15.warehouseId) || process.env.CUSTOM_WAREHOUSE || null;
    var puidList = [];
    var tooltipWithdrawalText = (ref1 = takeback === null || takeback === void 0 ? void 0 : takeback.order_withdrawal_text[0]) === null || ref1 === void 0 ? void 0 : ref1.text;
    var ref11 = (0,react.useState)(''), downloadLink = ref11[0], setDownloadLink = ref11[1];
    var ref12 = (0,react.useState)(false), isDownloadLoading = ref12[0], setIsDownloadLoading = ref12[1];
    var query = (0,router.useRouter)().query;
    var fetchRightOfWithdrawal = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(currentOrderNumber) {
            var rightOfWithdrawalResponse, secondHandRightOfWithdrawalInformations, isDisabled;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getRightOfWithdrawalInfo(currentOrderNumber);
                    case 2:
                        rightOfWithdrawalResponse = _ctx.sent;
                        secondHandRightOfWithdrawalInformations = getSecondHandRightOfWithdrawalInformations(rightOfWithdrawalResponse.response);
                        isDisabled = isAtLeastOneSecondHandItemIsReturnable(secondHandRightOfWithdrawalInformations);
                        setIsManageOrderButtonDisabled(isDisabled);
                        setSecondHandRightOfWithdrawalInformations(secondHandRightOfWithdrawalInformations);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchRightOfWithdrawal(currentOrderNumber) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSecondHandRightOfWithdrawalInformations = function(rightOfWithdrawalInformations) {
        return rightOfWithdrawalInformations === null || rightOfWithdrawalInformations === void 0 ? void 0 : rightOfWithdrawalInformations.filter(function(rightOfWithdrawalInfo) {
            return puidList.includes(rightOfWithdrawalInfo.puid);
        });
    };
    // in order to know if order manage button si disabled or not.
    var isAtLeastOneSecondHandItemIsReturnable = function(secondHandRightOfWithdrawalInformations) {
        return !!(secondHandRightOfWithdrawalInformations === null || secondHandRightOfWithdrawalInformations === void 0 ? void 0 : secondHandRightOfWithdrawalInformations.find(function(info) {
            return info.returnable === true;
        }));
    };
    var handleActiveCurrentOrder = function() {
        if (savForm) {
            onOpenSavForm && onOpenSavForm(currentOrderNumber1);
            return;
        }
        setActiveManageOrder(true);
    };
    var cancelReturn = function() {
        // we reset everything
        setActiveManageOrder(false);
        setProductSelection(false);
        setProductToReturn([]);
        setDownloadLink('');
        setProductReturningReasons({});
    };
    var handleProductSelection = function(Sku, id, quantity, token, item, orderNumber, warehouseId, carrierId) {
        setProductSelection(true);
        var productSelectionArray = _toConsumableArray(productToReturn);
        // we first check if the product selected is already in the array of selected products
        if (productToReturn.find(function(product) {
            return product.id === id;
        })) {
            // if it is true the we remove the row in the array and we adapt the prices
            var index = productToReturn.findIndex(function(product) {
                return product.id === id;
            });
            productSelectionArray.splice(index, 1);
            // if nothing selected, disable generate button
            setProductSelection(productSelectionArray.length !== 0);
            // Remove returning reasons for this product
            var newReturningReasons = _objectSpread({}, productReturningReasons);
            delete newReturningReasons[id];
            setProductReturningReasons(newReturningReasons);
        } else {
            // if it is false we push a new row in the array of selected products and we adapt the prices
            productSelectionArray.push({
                id: id,
                Sku: Sku,
                expand: true,
                product: item.variant,
                quantity: quantity,
                orderToken: token,
                orderNumber: orderNumber,
                warehouseId: warehouseId,
                carrierId: carrierId
            });
        }
        setProductToReturn(productSelectionArray);
    };
    var handleReturningReasonChange = function(productId, returningRaisonId) {
        setProductReturningReasons(function(prev) {
            return _objectSpread({}, prev, _defineProperty({}, productId, _objectSpread({}, prev[productId], {
                returningRaisonId: returningRaisonId
            })));
        });
    };
    var handleReturningReasonCommentChange = function(productId, returningComment) {
        setProductReturningReasons(function(prev) {
            return _objectSpread({}, prev, _defineProperty({}, productId, _objectSpread({}, prev[productId], {
                returningComment: returningComment
            })));
        });
    };
    var sendProductsToReturn = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, productData, products, data, ref13, ref14;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // we prepare the data to send, the send it and check if response is ok, then we download the recieved file
                        setIsDownloadLoading(true);
                        productData = [];
                        productToReturn.map(function(product) {
                            var returningReason = productReturningReasons[product.id] || {};
                            productData.push({
                                lizeeSKU: product.Sku,
                                quantity: product.quantity,
                                orderToken: product.orderToken,
                                returningRaisonId: returningReason.returningRaisonId,
                                returningComment: returningReason.returningComment
                            });
                        });
                        products = {
                            products: productData,
                            gender: user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.gender,
                            warehouseId: productToReturn[0].warehouseId,
                            carrierId: productToReturn[0].carrierId,
                            omsOrderId: productToReturn[0].orderNumber,
                            rightOfWithdrawal: true,
                            email: undefined
                        };
                        if (!localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN)) {
                            products.email = query.email;
                        }
                        _ctx.next = 8;
                        return postProductToReturn(products);
                    case 8:
                        data = _ctx.sent;
                        if (!(data.type === 'POST_PRODUCT_TO_RETURN_SUCCESS')) {
                            _ctx.next = 21;
                            break;
                        }
                        ;
                        if (!((ref13 = data === null || data === void 0 ? void 0 : data.response[0]) === null || ref13 === void 0 ? void 0 : ref13.pdfUrl)) {
                            _ctx.next = 19;
                            break;
                        }
                        ;
                        _ctx.next = 15;
                        return setDownloadLink((ref14 = data === null || data === void 0 ? void 0 : data.response[0]) === null || ref14 === void 0 ? void 0 : ref14.pdfUrl);
                    case 15:
                        _ctx.next = 17;
                        return (0,utils/* downloadURI */.l_)(data.response[0].pdfUrl, "".concat("millet", "_").concat(data.response[0].trackingCode));
                    case 17:
                        _ctx.next = 19;
                        return setIsDownloadLoading(false);
                    case 19:
                        _ctx.next = 22;
                        break;
                    case 21:
                        {
                            setIsDownloadLoading(false);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendProductsToReturn() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchRightOfWithdrawal(currentOrderNumber1);
    }, []);
    // Group units by quality for display when quantity selector is enabled
    var renderSecondHandItems = function() {
        return order === null || order === void 0 ? void 0 : order.secondHandOrderList.map(function(secondHandItem) {
            var // Add all puids to the list for right of withdrawal checks
            ref19, ref16;
            secondHandItem === null || secondHandItem === void 0 ? void 0 : (ref19 = secondHandItem.units) === null || ref19 === void 0 ? void 0 : ref19.forEach(function(unit) {
                return puidList.push(unit.puid);
            });
            // Group by quality if quantity selector is enabled
            if (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector) {
                var ref17;
                var groupedByQuality = secondHandItem === null || secondHandItem === void 0 ? void 0 : (ref17 = secondHandItem.units) === null || ref17 === void 0 ? void 0 : ref17.reduce(function(acc, unit) {
                    var quality = unit === null || unit === void 0 ? void 0 : unit.productCondition;
                    if (!acc[quality]) {
                        acc[quality] = {
                            units: [],
                            totalPrice: 0
                        };
                    }
                    acc[quality].units.push(unit);
                    acc[quality].totalPrice += (unit === null || unit === void 0 ? void 0 : unit.productPrice) || secondHandItem.total / secondHandItem.units.length;
                    return acc;
                }, {});
                return Object.entries(groupedByQuality || {}).map(function(param, groupIndex) {
                    var _param = _slicedToArray(param, 2), quality = _param[0], group = _param[1];
                    var ref20, ref18;
                    // Check if any unit in the group is returnable
                    var isAnyReturnable = group.units.some(function(unit) {
                        var ref;
                        return (ref = secondHandRightOfWithdrawalInformations1 === null || secondHandRightOfWithdrawalInformations1 === void 0 ? void 0 : secondHandRightOfWithdrawalInformations1.find(function(info) {
                            return info.puid === unit.puid;
                        })) === null || ref === void 0 ? void 0 : ref.returnable;
                    });
                    var isSelected = productToReturn.find(function(product) {
                        return product.id === "".concat(secondHandItem.id, "-").concat(quality);
                    });
                    var productReturningReason = productReturningReasons["".concat(secondHandItem.id, "-").concat(quality)] || {};
                    var hasReturnedUnits = group.units.some(function(unit) {
                        return unit.isReturned;
                    });
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.productCard,
                                children: [
                                    activeManageOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)(classes.productCardCheckbox, 'checkbox'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                            in: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                checked: isSelected,
                                                name: secondHandItem.product.name,
                                                "data-testid": "order__checkbox--".concat(quality, "-").concat(groupIndex),
                                                disableRipple: true,
                                                size: "small",
                                                disabled: !isAnyReturnable,
                                                onChange: function() {
                                                    return handleProductSelection(secondHandItem.product.variants[0].sku, "".concat(secondHandItem.id, "-").concat(quality), group.units.length, order === null || order === void 0 ? void 0 : order.tokenValue, secondHandItem, order.orderNumber, warehouseId1, order.shipments[0].method.carrierId);
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.productCardImg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                            classes: classes.imgProduct,
                                            imagePaths: secondHandItem.product.images[0],
                                            settings: {
                                                width: 50,
                                                ar: '1-1',
                                                defaultImage: main === null || main === void 0 ? void 0 : (ref20 = main.data) === null || ref20 === void 0 ? void 0 : ref20.default_image
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.productCardContent,
                                        children: [
                                            hasReturnedUnits && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.productName, classes.productReturned),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: takeback === null || takeback === void 0 ? void 0 : takeback.product_returned,
                                                    defaultText: t('texts:account:product_returned')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.productName,
                                                children: [
                                                    "x",
                                                    group.units.length,
                                                    "\xa0",
                                                    secondHandItem.product.name,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: "\xa0-\xa0"
                                                    }),
                                                    secondHandItem.product.variants[0].size
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.productName,
                                                children: (ref18 = states["".concat(quality)]) === null || ref18 === void 0 ? void 0 : ref18.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.productName,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                    amount: group.totalPrice
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isSelected && activeManageOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturningReasonForm/* default */.Z, {
                                productId: "".concat(secondHandItem.id, "-").concat(quality),
                                returningRaisonId: productReturningReason.returningRaisonId || null,
                                returningComment: productReturningReason.returningComment || '',
                                onReturningRaisonChange: handleReturningReasonChange,
                                onReturningCommentChange: handleReturningReasonCommentChange,
                                account: account,
                                t: t
                            })
                        ]
                    }, "".concat(secondHandItem.id, "-").concat(quality, "-").concat(groupIndex)));
                });
            }
            // Default behavior: display each unit individually
            return secondHandItem === null || secondHandItem === void 0 ? void 0 : (ref16 = secondHandItem.units) === null || ref16 === void 0 ? void 0 : ref16.map(function(secondHandUnit, index) {
                var ref, ref21, ref22;
                var isDisabledCheckbox = !((ref = secondHandRightOfWithdrawalInformations1 === null || secondHandRightOfWithdrawalInformations1 === void 0 ? void 0 : secondHandRightOfWithdrawalInformations1.find(function(unit) {
                    return unit.puid === secondHandUnit.puid;
                })) === null || ref === void 0 ? void 0 : ref.returnable);
                var isSelected = productToReturn.find(function(product) {
                    return product.id === secondHandItem.id;
                });
                var productReturningReason = productReturningReasons[secondHandItem.id] || {};
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.productCard,
                            children: [
                                activeManageOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.productCardCheckbox, 'checkbox'),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                        in: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            checked: isSelected,
                                            name: secondHandItem.product.name,
                                            "data-testid": "order__checkbox--".concat(index),
                                            disableRipple: true,
                                            size: "small",
                                            disabled: isDisabledCheckbox,
                                            onChange: function() {
                                                return handleProductSelection(secondHandItem.product.variants[0].sku, secondHandItem.id, 1, order === null || order === void 0 ? void 0 : order.tokenValue, secondHandItem, order.orderNumber, warehouseId1, order.shipments[0].method.carrierId);
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.productCardImg,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                        classes: classes.imgProduct,
                                        imagePaths: secondHandItem.product.images[0],
                                        settings: {
                                            width: 50,
                                            ar: '1-1',
                                            defaultImage: main === null || main === void 0 ? void 0 : (ref21 = main.data) === null || ref21 === void 0 ? void 0 : ref21.default_image
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.productCardContent,
                                    children: [
                                        secondHandUnit.isReturned && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.productName, classes.productReturned),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: takeback === null || takeback === void 0 ? void 0 : takeback.product_returned,
                                                defaultText: t('texts:account:product_returned')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.productName,
                                            children: [
                                                secondHandItem.product.name,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "\xa0-\xa0"
                                                }),
                                                secondHandItem.product.variants[0].size
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.productName,
                                            children: (ref22 = states["".concat(secondHandUnit.productCondition)]) === null || ref22 === void 0 ? void 0 : ref22.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.productName,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: secondHandItem.total
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        isSelected && activeManageOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturningReasonForm/* default */.Z, {
                            productId: secondHandItem.id,
                            returningRaisonId: productReturningReason.returningRaisonId || null,
                            returningComment: productReturningReason.returningComment || '',
                            onReturningRaisonChange: handleReturningReasonChange,
                            onReturningCommentChange: handleReturningReasonCommentChange,
                            account: account,
                            t: t
                        })
                    ]
                }, "".concat(secondHandUnit.puid, "-").concat(index)));
            });
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            renderSecondHandItems(),
            activeManageOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                textAlign: 'center',
                className: (0,clsx_m/* default */.Z)(classes.returnCtaContainer, 'return_cta_button'),
                children: productSelection && downloadLink === '' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    size: "small",
                    "data-testid": 'downloadBtn',
                    variant: "contained",
                    color: "primary",
                    disabled: isDownloadLoading || !productSelection,
                    onClick: function() {
                        return sendProductsToReturn();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: isDownloadLoading ? classes.hide : classes.show,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: account === null || account === void 0 ? void 0 : (ref2 = account.data) === null || ref2 === void 0 ? void 0 : ref2.order_details_generate,
                                defaultText: t('texts:account:order_details_generate')
                            })
                        }),
                        isDownloadLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                    ]
                }) : downloadLink !== '' && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadLink/* default */.Z, {
                    downloadLink: downloadLink,
                    data: account === null || account === void 0 ? void 0 : (ref3 = account.data) === null || ref3 === void 0 ? void 0 : ref3.order_details_download,
                    defaultText: t('texts:account:order_details_download')
                })
            }),
            !activeManageOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.orderDetailsRow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTooltip, {
                    placement: 'top',
                    title: !isManageOrderButtonDisabled ? tooltipWithdrawalText : '',
                    arrow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: "small",
                            variant: "contained",
                            color: "secondary",
                            onClick: function() {
                                return handleActiveCurrentOrder();
                            },
                            className: (0,clsx_m/* default */.Z)(classes.orderDetailsBtn, 'btn--order-details'),
                            disabled: !isManageOrderButtonDisabled,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: takeback === null || takeback === void 0 ? void 0 : takeback.order_second_hand_details,
                                defaultText: t('texts:account:order_second_hand_details')
                            })
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.orderDetailsRow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    size: 'small',
                    className: (0,clsx_m/* default */.Z)(classes.simpleButtonDanger, classes.simpleButton),
                    onClick: function() {
                        return cancelReturn();
                    },
                    disableRipple: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: account === null || account === void 0 ? void 0 : (ref4 = account.data) === null || ref4 === void 0 ? void 0 : ref4.order_details_manage_cancel,
                        defaultText: t('texts:account:order_details_manage_cancel')
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Order_SecondHandOrderList = ((0,es/* connect */.$j)(mapStateToProps, null)(SecondHandOrderList));

// EXTERNAL MODULE: ./components/Order/RentalReturnLabelDownload.tsx
var RentalReturnLabelDownload = __webpack_require__(53706);
;// CONCATENATED MODULE: ./components/Order/SecondHandAndRentalOrderList.tsx

















function SecondHandAndRentalOrderList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SecondHandAndRentalOrderList_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SecondHandAndRentalOrderList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SecondHandAndRentalOrderList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SecondHandAndRentalOrderList = function(param) {
    var takeback = param.takeback, orders = param.orders, main = param.main, postProductToReturn = param.postProductToReturn, getRightOfWithdrawalInfo = param.getRightOfWithdrawalInfo, handleDownloadInvoice = param.handleDownloadInvoice, invoiceDownloadError = param.invoiceDownloadError, prismicAccount = param.prismicAccount, showSizes = param.showSizes, putUserOrder = param.putUserOrder, getUserOrders = param.getUserOrders, savForm = param.savForm, onOpenSavForm = param.onOpenSavForm, settings = param.settings;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = (0,Order_style/* default */.Z)();
    var ref9 = (0,react.useState)({
        open: false,
        currentOrder: null
    }), openModal = ref9[0], setOpenModal = ref9[1];
    var handleOpen = function(currentOrder) {
        setOpenModal({
            open: true,
            currentOrder: currentOrder
        });
    };
    var handleClose = function() {
        setOpenModal({
            open: false,
            currentOrder: null
        });
    };
    function handleCancel(order) {
        return _handleCancel.apply(this, arguments);
    }
    function _handleCancel() {
        _handleCancel = SecondHandAndRentalOrderList_asyncToGenerator(runtime_default().mark(function _callee(order) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setOpenModal({
                            open: false,
                            currentOrder: null
                        });
                    case 2:
                        _ctx.next = 4;
                        return putUserOrder(order.tokenValue);
                    case 4:
                        response = _ctx.sent;
                        if (!(response.type === 'PUT_USER_ORDER_SUCCESS')) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 8;
                        return getUserOrders();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleCancel.apply(this, arguments);
    }
    var ordersInformations = (0,react.useMemo)(function() {
        return orders === null || orders === void 0 ? void 0 : orders.map(function(order, index) {
            return getOrderInformations(order, index, orders.length);
        });
    }, [
        orders
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.takeBackAndRentalOrderList,
        children: (ordersInformations === null || ordersInformations === void 0 ? void 0 : ordersInformations.length) > 0 && ordersInformations.map(function(order, index) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "order--".concat(order.state),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.orderHeader,
                        children: [
                            order.state === constants/* ORDER_STATE.CANCELLED */.eZ.CANCELLED && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.circleDefault, classes.circleWarning)
                            }),
                            order.state === constants/* ORDER_STATE.COMING */.eZ.COMING && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.circleDefault, classes.circlePrimary)
                            }),
                            order.state === constants/* ORDER_STATE.RETURN */.eZ.RETURN && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.circleDefault, classes.circleSecondary)
                            }),
                            order.state === constants/* ORDER_STATE.FINISHED */.eZ.FINISHED && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.circleDefault
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.orderTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: 'h4',
                                        color: 'textSecondary',
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref = prismicAccount.data) === null || ref === void 0 ? void 0 : ref.command,
                                                defaultText: t('texts:account:command')
                                            }),
                                            "\xa0",
                                            order.orderNumber
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body1',
                                        component: 'div',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: order.total
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)([
                            'order__item',
                            classes.orderItem
                        ], order.state === constants/* ORDER_STATE.CANCELLED */.eZ.CANCELLED && classes.orderItemCancelled, order.state === constants/* ORDER_STATE.COMING */.eZ.COMING && classes.orderItemComing, order.state === constants/* ORDER_STATE.RETURN */.eZ.RETURN && classes.orderItemReturn, order.state === constants/* ORDER_STATE.FINISHED */.eZ.FINISHED && classes.orderItem, order.lastOrder && [
                            'order__item--last',
                            classes.orderItemLast, 
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.orderHeader,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    order.state === constants/* ORDER_STATE.CANCELLED */.eZ.CANCELLED && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body1',
                                                        color: 'inherit',
                                                        className: classes.warning,
                                                        children: [
                                                            t('texts:account:cancelled'),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                                children: [
                                                                    "\xa0-\xa0",
                                                                    order.cancelledAt ? order.cancelledAt : order.orderStartLeasingDate
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    order.state === constants/* ORDER_STATE.COMING */.eZ.COMING && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body1',
                                                        color: 'primary',
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref1 = prismicAccount.data) === null || ref1 === void 0 ? void 0 : ref1.date,
                                                                defaultText: t('texts:account:date')
                                                            }),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: order.checkoutCompletedAt
                                                            })
                                                        ]
                                                    }),
                                                    order.state === constants/* ORDER_STATE.RETURN */.eZ.RETURN && (order === null || order === void 0 ? void 0 : order.rentalOrderList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body1',
                                                        color: 'secondary',
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref2 = prismicAccount.data) === null || ref2 === void 0 ? void 0 : ref2.date,
                                                                defaultText: t('texts:account:date')
                                                            }),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: order.orderEndLeasingDate
                                                            })
                                                        ]
                                                    }),
                                                    order.state === constants/* ORDER_STATE.FINISHED */.eZ.FINISHED && (order === null || order === void 0 ? void 0 : order.rentalOrderList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body1',
                                                        color: 'textPrimary',
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref3 = prismicAccount.data) === null || ref3 === void 0 ? void 0 : ref3.returned_at,
                                                                defaultText: t('texts:account:returned_at')
                                                            }),
                                                            "\xa0",
                                                            order.orderEndLeasingDate
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (order === null || order === void 0 ? void 0 : order.isCancellable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)('order-cancel', classes.cancelArea),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    size: "small",
                                                    disableRipple: true,
                                                    className: (0,clsx_m/* default */.Z)('order-cancel__btn', classes.cancelBtn),
                                                    onClick: function() {
                                                        return handleOpen(order.orderNumber);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref4 = prismicAccount.data) === null || ref4 === void 0 ? void 0 : ref4.cancel_order_cta_modal,
                                                        defaultText: t('texts:account:cancel_order:cta_modal')
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        component: 'div',
                                        children: "".concat(order.shippingAddress.street, " ").concat(order.shippingAddress.city, " ").concat(order.shippingAddress.postcode === '00000' ? '' : order.shippingAddress.postcode)
                                    }),
                                    (order === null || order === void 0 ? void 0 : order.rentalOrderList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.orderContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.OrderTitle,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    color: 'textSecondary',
                                                    variant: 'h5',
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref5 = prismicAccount.data) === null || ref5 === void 0 ? void 0 : ref5.leasing_date_from,
                                                            defaultText: t('texts:account:leasing_date_from')
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: order.orderStartLeasingDate
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: prismicAccount === null || prismicAccount === void 0 ? void 0 : (ref6 = prismicAccount.data) === null || ref6 === void 0 ? void 0 : ref6.leasing_date_to,
                                                            defaultText: t('texts:account:leasing_date_to')
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: order.orderEndLeasingDate
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_RentalOrderList, {
                                                order: order,
                                                showSizes: showSizes
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RentalReturnLabelDownload/* default */.Z, {
                                                orderNumber: order.orderNumber,
                                                account: prismicAccount,
                                                t: t
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (order === null || order === void 0 ? void 0 : order.secondHandOrderList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.orderContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.OrderTitle,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'h5',
                                            color: 'textSecondary',
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.take_back_list_title,
                                                    defaultText: t('texts:account:take_back_list_title')
                                                }),
                                                "\xa0 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: order.checkoutCompletedAt
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_SecondHandOrderList, {
                                        order: order,
                                        main: main,
                                        takeback: takeback === null || takeback === void 0 ? void 0 : takeback.data,
                                        account: prismicAccount,
                                        currentOrderNumber: order.orderNumber,
                                        postProductToReturn: postProductToReturn,
                                        getRightOfWithdrawalInfo: getRightOfWithdrawalInfo,
                                        savForm: savForm,
                                        onOpenSavForm: onOpenSavForm,
                                        settings: settings
                                    })
                                ]
                            }),
                            handleDownloadInvoice && !!(order === null || order === void 0 ? void 0 : (ref8 = order.invoice) === null || ref8 === void 0 ? void 0 : ref8.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.downloadInvoiceButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceButton/* default */.Z, {
                                    accountRes: prismicAccount,
                                    orderToken: order.tokenValue,
                                    t: t,
                                    handleDownloadInvoice: handleDownloadInvoice,
                                    invoiceDownloadError: invoiceDownloadError,
                                    isSub: constants/* isSubscription */.Nn
                                })
                            })
                        ]
                    }),
                    (order === null || order === void 0 ? void 0 : order.isCancellable) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_ModalCancelOrder, {
                        order: order,
                        prismicAccountData: prismicAccount === null || prismicAccount === void 0 ? void 0 : prismicAccount.data,
                        openModal: openModal,
                        handleClose: handleClose,
                        handleCancel: handleCancel
                    })
                ]
            }, index));
        })
    }));
};
/* harmony default export */ var Order_SecondHandAndRentalOrderList = (SecondHandAndRentalOrderList);


/***/ }),

/***/ 52957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useThrottle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * The useThrottle hook can be used to enforce a delay between calls to the throttled function, allowing it to be called only once within the specified time period.
 * @param fn any function
 * @param delay The time calls to the function should be disregarded
 * @param deps Any deps to the underlaying useCallback
 * @returns a throttled function
 */ var useThrottle = function(fn, delay) {
    var timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // Returning a throttled version
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (timer.current === null) {
            // If there is no timer currently running
            fn.apply(void 0, _toConsumableArray(args));
            timer.current = setTimeout(function() {
                // Set a timer to clear the timerFlag after the specified delay
                timer.current = null // Clear the timerFlag to allow the main function to be executed again
                ;
            }, delay);
        }
    }, [
        fn
    ]);
};


/***/ })

}]);